exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sign-in-override {\n    padding-left: 0px !important;\n    padding-right: 5px !important;\n}\n\n.sign-up-override {\n    padding-left: 5px !important;\n}\n\n.custom-divider {\n    display: inline-block;\n    border-right: 2px inset snow;\n    padding: 2px 0px 2px 0px;\n    vertical-align: middle;\n    height: 24px;\n}\n\n.lang-selected {\n    font-weight: bold;\n}\n\n.nav-divider {\n    display: inline-block;\n    width: 1px;\n    height: 40px;\n    background-color: #fafafa;\n    position: relative;\n    top: 10px;\n    opacity: 0.15;\n    content: '';\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/base/navigator/navigator.component.css
// module id = 813
// module chunks = 0